import React from "react";

import { transformViewDate } from "utils/date-utils";
import { getPersonFullName } from "utils/person";
import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import useStyles from "./styles";

interface IProps {
  note: racehorse360.IWorkoutRequestRejectionComment;
}

const REJECTION_NOTE_LIMIT = 90;

const RejectionNote = (props: IProps) => {
  const { note } = props;
  const classes = useStyles();

  const noteContent =
    note.body.length > REJECTION_NOTE_LIMIT
      ? `${note.body.slice(0, REJECTION_NOTE_LIMIT)}...`
      : note.body;
  const noteDate = transformViewDate(note.updatedOn, null, "MM/dd/yy h:mm a");

  return (
    <>
      {note && (
        <div className={classes.rejectionNoteContainer}>
          <div className={classes.rejectionNoteHeader}>
            {"Rejection Note"}
            <span className={classes.margin}>
              {getPersonFullName(note.updatedBy, "%f %m %L")}
            </span>
            <span className={classes.margin}>{noteDate}</span>
          </div>
          <div>{noteContent}</div>
        </div>
      )}
    </>
  );
};

export default RejectionNote;
